// extracted by mini-css-extract-plugin
export default {"number":"FormNumber_number__1Kfby","number_unit":"FormNumber_number_unit__rNWnS","number_btn":"FormNumber_number_btn__ucf5R"};